import basic from "./basic";
import concerned from "./concerned";
import disbelief from "./disbelief";
import eating from "./eating";
import grimace from "./grimace";
import sad from "./sad";
import screamOpen from "./scream-open";
import serious from "./serious";
import smile from "./smile";
import tongue from "./tongue";
import twinkle from "./twinkle";
import vomit from "./vomit";

export default {
	basic,
	concerned,
	disbelief,
	eating,
	grimace,
	sad,
	screamOpen,
	serious,
	smile,
	tongue,
	twinkle,
	vomit,
};



// WEBPACK FOOTER //
// ./src/face/mouth/index.js